<app-loading-overlay [isLoading]="isLoading"></app-loading-overlay>
<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzFooter]="null"
  [nzWidth]="'80vw'"
  [nzMaskClosable]="false"
  nzWrapClassName="segment-view-modal-wrap"
  (nzOnCancel)="onClose()"
>
  <ng-container *nzModalContent>
    <ng-container *ngIf="row as selectedRow">
      <section class="segment-view-modal">
        <div class="details-grid">
          <div>
            <span nz-typography class="nfl-form-label">Segment Name</span>
            <span>{{ segmentName }}</span>
          </div>
          <div>
            <span nz-typography class="nfl-form-label">Segmented Fans</span>
            <span>{{ selectedRow.segmentedFans }}</span>
          </div>
          <div>
            <span nz-typography class="nfl-form-label">Created By</span>
            <span>{{ selectedRow.createdBy }}</span>
          </div>
          <div>
            <span nz-typography class="nfl-form-label">Created On</span>
            <span>{{ selectedRow.createdOn | dateTime }}</span>
          </div>
          <div class="description-row">
            <span nz-typography class="nfl-form-label">Segment Description</span>
            <span>{{ segmentDescription }}</span>
          </div>
        </div>

        <nz-collapse class="collapse-panel" nzExpandIconPosition="end" nzSize="small">
          <nz-collapse-panel nzHeader="Select Table(s)" [nzActive]="true" [nzDisabled]="false" nzExpandedIcon="plus">
            <div class="table-selection-grid">
              <div class="selection-field">
                <span class="nfl-form-label">Database</span>
                <span>{{ parsedDatabaseName || '-' }}</span>
              </div>
              <div class="selection-field">
                <span class="nfl-form-label">Base Table</span>
                <span>{{ parsedBaseTableName || '-' }}</span>
              </div>
              <div class="selection-field selection-field-full">
                <span class="nfl-form-label">Table Name</span>
                <span>{{ parsedTableName || '-' }}</span>
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>

        <nz-collapse class="collapse-panel" nzExpandIconPosition="end" nzSize="small">
          <nz-collapse-panel nzHeader="Add Conditions" [nzActive]="true" [nzDisabled]="false" nzExpandedIcon="plus">
            <ng-container *ngIf="hasConditions && parsedConditions; else noConditionsTemplate">
              <ng-container
                *ngTemplateOutlet="conditionGroupTemplate; context: { $implicit: parsedConditions, isRoot: true }"
              ></ng-container>
            </ng-container>
            <ng-template #noConditionsTemplate>
              <p nz-typography class="no-conditions-text">No conditions available for this segment.</p>
            </ng-template>
          </nz-collapse-panel>
        </nz-collapse>

        <nz-collapse class="collapse-panel" nzExpandIconPosition="end" nzSize="small">
          <nz-collapse-panel nzHeader="Generated Query" [nzActive]="false" [nzDisabled]="false" nzExpandedIcon="plus">
            <div class="query-panel">
              <app-monaco-editor [value]="queryText" [readOnly]="true"></app-monaco-editor>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </section>
    </ng-container>
  </ng-container>
</nz-modal>

<ng-template #conditionGroupTemplate let-group let-isRoot="isRoot">
  <div class="group-container" [class.root-group]="isRoot">
    <ng-container *ngFor="let entry of group.entries; trackBy: trackByEntry">
      <div class="operator-panel" *ngIf="entry.joinWith">{{ entry.joinWith }}</div>

      <ng-container *ngIf="entry.type === 'row' && entry.row as conditionRow">
        <nz-card>
          <div nz-row [nzGutter]="[16, 16]" class="condition-row-grid">
            <div nz-col nzSpan="8">
              <div class="condition-field">
                <span class="nfl-form-label">Column</span>
                <span>{{ conditionRow.column }}</span>
              </div>
            </div>
            <div nz-col nzSpan="4">
              <div class="condition-field">
                <span class="nfl-form-label">Operator</span>
                <span>{{ conditionRow.operator }}</span>
              </div>
            </div>
            <div nz-col nzSpan="12">
              <div class="condition-field">
                <span class="nfl-form-label">Value</span>
                <span class="condition-value">{{ conditionRow.value }}</span>
              </div>
            </div>
          </div>
        </nz-card>
      </ng-container>

      <ng-container *ngIf="entry.type === 'group' && entry.group as nestedGroup">
        <ng-container *ngTemplateOutlet="conditionGroupTemplate; context: { $implicit: nestedGroup, isRoot: false }">
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
